import React from "react";
import "../styles/main.css"
import "../styles/variables.css"
import "../styles/links.css"
import "../styles/docs.css"
import trello from './images/trello.png';
import slack from './images/slack.png';
import whatsapp from './images/whatsapp.png';
import drive from './images/googledrive.png';
import esn from './images/esn.png';
import linktree from './images/linktree.png';
import tiktok from './images/tiktok.png';
import instagram from './images/instagram.png';
import NavHeader from "./NavHeader";



function Links() {

    return (
        <div className="main-page">

            <NavHeader />

            <div className="title docs-header">
                Useful Links
            </div>

            <div className="links-structure">
                <div className="links-element">
                    <div className="links-icon-wrapper">
                        <img src={trello} alt="Trello" className="links-icon"></img>
                    </div>
                    <div className="links-title">Trello</div>
                    <div className="links-description">Plan & Organize Events</div>


                </div>
                <div className="links-element">
                    <div className="links-icon-wrapper">
                        <img src={slack} alt="slack" className="links-icon"></img>
                    </div>
                    <div className="links-title">Slack</div>
                    <div className="links-description">Communicate with other members</div>


                </div>
                <div className="links-element">
                    <div className="links-icon-wrapper">
                        <img src={whatsapp} alt="whatsapp" className="links-icon"></img>
                    </div>
                    <div className="links-title">Whatsapp</div>
                    <div className="links-description">SOS communication & Erasmus groups</div>


                </div>
                <div className="links-element">
                    <div className="links-icon-wrapper">
                        <img src={drive} alt="drive" className="links-icon"></img>
                    </div>
                    <div className="links-title">ESN Drive</div>
                    <div className="links-description">Everything is here</div>


                </div>
                <div className="links-element">
                    <div className="links-icon-wrapper">
                        <img src={esn} alt="esn" className="links-icon"></img>
                    </div>
                    <div className="links-title">ESN Website</div>
                    <div className="links-description">Everything about ESN & our stakeholders</div>


                </div>
                <div className="links-element">
                    <div className="links-icon-wrapper">
                        <img src={instagram} alt="instagram" className="links-icon"></img>
                    </div>
                    <div className="links-title">Instagram</div>
                    <div className="links-description">Our main social media platform</div>


                </div>
                <div className="links-element">
                    <div className="links-icon-wrapper">
                        <img src={linktree} alt="linktree" className="links-icon"></img>
                    </div>
                    <div className="links-title">Linktree</div>
                    <div className="links-description">Useful links for the Erasmus</div>


                </div>
                <div className="links-element">
                    <div className="links-icon-wrapper">
                        <img src={tiktok} alt="tiktok" className="links-icon"></img>
                    </div>
                    <div className="links-title">Tiktok</div>
                    <div className="links-description">Showcase of ESN Lisboa's coolness</div>


                </div>

            </div>

        </div>
    );
}
export default Links;
